<template>
  <div class="banner">
    <div class="swiper-container" id="homebanner">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(val, key) in res" :key="key">
          <a :href="val.link"><img :src="val.url"/></a>
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination" id="banner-pagination" v-if="res.length>1"></div>
      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev" id="banner-prev" v-if="res.length>1"></div>
      <div class="swiper-button-next" id="banner-next" v-if="res.length>1"></div>

      <!-- 如果需要滚动条 -->
      <!-- <div class="swiper-scrollbar"></div> -->
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "banner",
  props: ["res"],
  data() {
    return {
      bannerSwiper:"",
      bannerSwiperOption:{
       // direction: "vertical", // 垂直切换选项
        loop: true, // 循环模式选项
        // 如果需要分页器
        pagination: {
          el: "#banner-pagination"
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: "#banner-next",
          prevEl: "#banner-prev"
        },
        // 如果需要滚动条
        scrollbar: {
          el: ".swiper-scrollbar"
        }
      },
      bannerList: [
        { url: require("@/assets/img/banner.png"), link: "" },
        { url: require("@/assets/img/banner.png"), link: "" },
        { url: require("@/assets/img/banner.png"), link: "" },
        { url: require("@/assets/img/banner.png"), link: "" }
      ]
    };
  },
  created() {},
  methods: {
    SwiperReady() {
      
      if (this.bannerSwiper) {
        this.bannerSwiper.destroy();
      } 
       this.$nextTick(() => {
         if(this.res.length<=1){
return false;
         }
          this.bannerSwiper = new Swiper(
            "#homebanner.swiper-container",
            this.bannerSwiperOption
          );
        });
    }
  },
  mounted() {
     window.onresize = () => {
      return (() => {
        this.SwiperReady();
      })();
    };
    //
    this.$nextTick(() => {
      setTimeout(() => {
        this.SwiperReady();
      }, 1000);
    });
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.swiper-container{
  img{width:100%;}
}
</style>
